// extracted by mini-css-extract-plugin
export default {"input":"F8-z","button":"G8-z","selected":"H8-z","unavailable":"I8-z","oos":"J8-z","image":"K8-z","paperCutDisabledOverlay":"L8-z"};